import { useEffect, useRef, useState, useCallback } from 'react';
import { api } from '../../../utils/api';

export const useModel3D = (planId) => {
  const [state, setState] = useState({ status: 'loading', model: null, error: null });
  const timer = useRef(null);
  const triggered = useRef(false);

  const poll = useCallback(async () => {
    if (!planId) return;
    try {
      const r = await api.get3DModel(planId);
      const { status, model, error } = r.data;
      if (status === 'none' && !triggered.current) {
        triggered.current = true;
        await api.generate3DModel(planId);
        setState({ status: 'generating', model: null, error: null });
        timer.current = setTimeout(poll, 4000);
        return;
      }
      setState({ status, model, error });
      if (status === 'generating') timer.current = setTimeout(poll, 4000);
    } catch (e) {
      setState({ status: 'failed', model: null, error: 'Kunde inte hämta 3D-modellen' });
    }
  }, [planId]);

  useEffect(() => {
    triggered.current = false;
    setState({ status: 'loading', model: null, error: null });
    poll();
    return () => clearTimeout(timer.current);
  }, [poll]);

  const regenerate = async () => {
    clearTimeout(timer.current);
    setState((s) => ({ ...s, status: 'generating' }));
    await api.generate3DModel(planId).catch(() => {});
    timer.current = setTimeout(poll, 4000);
  };

  return { ...state, regenerate };
};
